import React from 'react';
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';
import { AdPlacementMmaBaseV2 } from '../mma-ad-placements-v2/mma-ad-placement-base-v2';
import { ResponsiveAdPlacementMmaBase } from '../responsive-ad-placements/responsive-mma-ad-placement-base';
import { withUAPLThemedStyles } from '../../with-themed-styles';
import {
  getPMaxMSNCarousel169x100Styles,
  getPMaxMicrosoftEdgeCarousel201x100Styles,
  getPMaxMSNWideImage4x1Styles,
  getPMaxBingSearchLandscapeImage191x100Styles,
} from '../../styles';

export const AdPlacementPMaxMSNCarousel169x100 = withPermissions((props1) => {
  const StyledBaseComp = (
    withUAPLThemedStyles(
      props => (
        <AdPlacementMmaBaseV2
          {...props}
          showShortHeadline={false}
          showLongHeadline
          showDescription={false}
          showCallToAction={false}
          showBusinessNameWithLogoTop={false}
          showAdChoiceIconArea
          isMultiLineLongHeadline={false}
          description={undefined}
          callToAction={undefined}
          showBusinessNameInAdChoiceArea
          showAdIcon
          showBrightStyleChoiceIcon
          showChoiceIcon
        />
      ),
      getPMaxMSNCarousel169x100Styles,
      { componentName: 'AdPlacementPMaxMSNCarousel169x100' }
    )
  );
  return <StyledBaseComp {...props1} />;
});

export const AdPlacementPMaxMicrosoftEdgeCarousel201x100 = withPermissions((props1) => {
  const StyledBaseComp = withUAPLThemedStyles(
    props => (
      <AdPlacementMmaBaseV2
        {...props}
        showShortHeadline
        isMultiLineShortHeadline={false}
        showLongHeadline={false}
        showFinalUrl={false}
        showDescription
        showCallToAction={false}
        showBusinessNameWithLogoTop
        showAdChoiceIconArea
        showAdIcon
        showChoiceIcon
        showBrightStyleChoiceIcon
        description={undefined}
        callToAction={undefined}
        showGradient
        showLogo
      />
    ),
    getPMaxMicrosoftEdgeCarousel201x100Styles,
    { componentName: 'AdPlacementPMaxMicrosoftEdgeCarousel201x100' }
  );
  return <StyledBaseComp {...props1} />;
});

export const AdPlacementPMaxMSNWideImage4x1 = withPermissions((props1) => {
  const StyledBaseComp = withUAPLThemedStyles(
    props => (
      <ResponsiveAdPlacementMmaBase
        {...props}
        showShortHeadline
        showLongHeadline={false}
        showFinalUrl
        showDescription
        showCallToAction
        showAdLabel
        showGradient
        showBusinessName={false}
      />
    ),
    getPMaxMSNWideImage4x1Styles,
    { componentName: 'AdPlacementPMaxMSNWideImage4x1' }
  );
  return <StyledBaseComp {...props1} />;
});

export const AdPlacementPMaxBingSearchLandscapeImage191x100 = withPermissions((props1) => {
  const StyledBaseComp = withUAPLThemedStyles(
    props => (
      <ResponsiveAdPlacementMmaBase
        {...props}
        showShortHeadline
        showLongHeadline={false}
        showFinalUrl
        showDescription
        showCallToAction
        showAdLabel
        showGradient={false}
        showBusinessName={false}
        showLogo
      />
    ),
    getPMaxBingSearchLandscapeImage191x100Styles,
    { componentName: 'AdPlacementPMaxBingSearchLandscapeImage191x100' }
  );
  return <StyledBaseComp {...props1} />;
});
